import { render, staticRenderFns } from "./presentation.vue?vue&type=template&id=5221e375&scoped=true"
import script from "./presentation.vue?vue&type=script&lang=js"
export * from "./presentation.vue?vue&type=script&lang=js"
import style0 from "./presentation.vue?vue&type=style&index=0&id=5221e375&prod&lang=css"
import style1 from "./presentation.vue?vue&type=style&index=1&id=5221e375&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5221e375",
  null
  
)

export default component.exports